module.exports = __webpack_public_path__ + "media/images/arrow-left-4d6352255c294683c8fd246a53caa246.svg";